"use strict";

import * as THREE from 'three';
import { DragControls } from "three/examples/jsm/controls/DragControls.js";
import { EventHandling } from './lib/EventHandling'
import { Corps_room } from './Corps_room';
import { Camera } from './lib/Camera';
import { Form } from './Corps_form';
import { Scene } from './lib/Scene';
import { math } from './lib/Drag';
import { Env } from './lib/Env';
import { ID } from './lib/ID';

// const dragControls = [];

/**
 * @class Corps_cabinet
 */
export class Corps_cabinet {

    data: any;
    corps_scene = false;
    ID: number;
    shadowMeshID: number;
    static width: number;
    static height: number;
    static depth: number;
    static descriptionWidthID: number = 0;
    static descriptionHeightID: number = 0;
    static descriptionDepthID: number = 0;
    static dimensionLineWidthID: number = 0;
    static dimensionLineHeightID: number = 0;
    static dimensionLineDepthID: number = 0;

    static dragControls: any[] = [];

    constructor(data: any, name = 'box', id_cart = 0) {
        this.data = data;
        this.cabinet(name, id_cart);
        this.shadowMesh();
        this.forms();
        this.setCabinetSize();
        this.accesories();
        this.helperPoints();
        this.position();
        // this.add_plane();
        this.dragControls();
    }

    setCabinetSize() {
        if (!Corps_cabinet.width || !Corps_cabinet.height || !Corps_cabinet.depth) {
            if ('corp' in Env.data.data) {
                if (Env.data.data.corp.width && Env.data.data.corp.height && Env.data.data.corp.depth) {
                    Corps_cabinet.width = Corps_cabinet.width ?? Env.data.data.corp.width;
                    Corps_cabinet.height = Corps_cabinet.height ?? Env.data.data.corp.height;
                    Corps_cabinet.depth = Corps_cabinet.depth ?? Env.data.data.corp.depth;
                }
            } else {
                const box = new THREE.Box3().setFromObject( ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ) );
                const size = box.getSize(new THREE.Vector3);
                Corps_cabinet.width = size.x / Env.size_units;
                Corps_cabinet.height = size.y / Env.size_units;
                Corps_cabinet.depth = size.z / Env.size_units;
            }
        }
    }

    static setWidthDescription(cabinetID: number, text: string, initValue = false): void {
        if (initValue) {
            Corps_cabinet.descriptionWidthID = 0;
        }
        if (Corps_cabinet.descriptionWidthID) {
            ( Scene.scene.getObjectById(cabinetID) as THREE.Object3D).remove( ( Scene.scene.getObjectById(Corps_cabinet.descriptionWidthID) as THREE.Object3D ) );
        }
        Corps_cabinet.descriptionWidthID = Corps_cabinet.description(cabinetID, text, new THREE.Vector3(Corps_cabinet.width * Env.size_units / 2, Corps_cabinet.height * Env.size_units + 100 * Env.size_units, 0));
        Corps_cabinet.dimensionLineWidthID = Corps_cabinet.addLine(cabinetID, Corps_cabinet.width * Env.size_units, 0xff0000, new THREE.Vector3(0, Corps_cabinet.height * Env.size_units + 80 * Env.size_units, 0), new THREE.Vector3(0, 0, 0));
    }

    static setHeightDescription(cabinetID: number, text: string, initValue = false): void {
        if (initValue) {
            Corps_cabinet.descriptionHeightID = 0;
        }
        if (Corps_cabinet.descriptionHeightID) {
            ( Scene.scene.getObjectById(cabinetID) as THREE.Object3D).remove( ( Scene.scene.getObjectById(Corps_cabinet.descriptionHeightID) as THREE.Object3D ) );
        }
        Corps_cabinet.descriptionHeightID = Corps_cabinet.description(cabinetID, text, new THREE.Vector3(Corps_cabinet.width * Env.size_units + 80 * Env.size_units, Corps_cabinet.height * Env.size_units / 2, 0));
        Corps_cabinet.dimensionLineHeightID = Corps_cabinet.addLine(cabinetID, Corps_cabinet.height * Env.size_units, 0x00ff00, new THREE.Vector3(Corps_cabinet.width * Env.size_units + 80 * Env.size_units, 0, 0), new THREE.Vector3(0, Math.PI, Math.PI / 2));
    }

    static setDepthDescription(cabinetID: number, text: string, initValue = false): void {
        if (initValue) {
            Corps_cabinet.descriptionDepthID = 0;
        }
        if (Corps_cabinet.descriptionDepthID) {
            ( Scene.scene.getObjectById(cabinetID) as THREE.Object3D ).remove( ( Scene.scene.getObjectById(Corps_cabinet.descriptionDepthID) as THREE.Object3D ) );
        }
        Corps_cabinet.descriptionDepthID = Corps_cabinet.description(cabinetID, text, new THREE.Vector3(Corps_cabinet.width * Env.size_units + 80 * Env.size_units, 0, Corps_cabinet.depth * Env.size_units / 2));
        Corps_cabinet.dimensionLineDepthID = Corps_cabinet.addLine(cabinetID, Corps_cabinet.depth * Env.size_units, 0x0000ff, new THREE.Vector3(Corps_cabinet.width * Env.size_units + 80 * Env.size_units, 0, 0), new THREE.Vector3(-Math.PI / 2, 0, -Math.PI / 2));
    }

    static description(cabinetID: number, text: string, position: THREE.Vector3): number {
        const offscreencanvas = new OffscreenCanvas(512, 512);
        const context = offscreencanvas.getContext('2d');
        if (context) {
            context.globalAlpha = 0;
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, 512, 512);
            context.globalAlpha = 1;
            context.font = '96px bold Verdana';
            context.textAlign = 'center';
            context.textBaseline = 'middle';
            context.fillStyle = '#000';
            context.fillText(text, 256, 256);
        }
        const texture = new THREE.CanvasTexture(offscreencanvas);
        const material = new THREE.SpriteMaterial({ map: texture });
        const sprite = new THREE.Sprite(material);
        // console.log(Corps_cabinet.width*Env.size_units/2)
        // sprite.position.x = Corps_cabinet.width/2;
        sprite.position.copy(position);
        ( Scene.scene.getObjectById(cabinetID) as THREE.Object3D ).add(sprite);
        return sprite.id;
        // const loader = new FontLoader();
        // const font = await loader.loadAsync('./lib/helvetiker_regular.typeface.json');
        // const geometry = new TextGeometry('Hello three.js!', {
        //     font: font,
        //     size: .2,
        //     height: 0,
        //     curveSegments: 12,
        //     bevelEnabled: true,
        //     bevelThickness: 0,
        //     bevelSize: 0,
        //     bevelOffset: 0,
        //     bevelSegments: 0
        // });
        // // const material = new THREE.MeshBasicMaterial({color: new THREE.Color(0xd4d4d4)});
        // const material = new THREE.SpriteMaterial({color: new THREE.Color(0xd4d4d4)});
        // const mesh = new THREE.Mesh(geometry, material);
        // Scene.scene.add(mesh)
    }

    async dragControls() {

        if (Env.cabinets_cart_data) {
            console.log(Corps_cabinet.dragControls)
            const index = Corps_cabinet.dragControls.length as number;
            Corps_cabinet.dragControls[index] = new DragControls([( Scene.scene.getObjectById(this.ID) as THREE.Object3D ) ], Camera.camera, Env.inputElement);
            const lastPosition = new THREE.Vector3();
            const wallsSegments = new Array(ID.room.walls.constructPoints.inside.length);
            let points;
            Corps_cabinet.dragControls[index].transformGroup = true;
            const sectionsOuterEdgesAllCabinets: any[] = [];
            Corps_cabinet.dragControls[index].addEventListener('drag', function (e) {
                mdrag(e);
            });
            Corps_cabinet.dragControls[index].addEventListener('dragstart', function (e) {
                start(e);
            });
            Corps_cabinet.dragControls[index].addEventListener('dragend', function (e) {
                dragEnd(e);
            });

            function start(e: any) {
                Camera.orbitControls.enabled = false;
                Corps_room.opacity.enabled = false;
                for (const i in Corps_cabinet.dragControls) {
                    if (parseInt(i) !== index) {
                        Corps_cabinet.dragControls[i].enabled = false;
                    }
                }
                lastPosition.copy(e.object.position);
                e.object.userData.y = e.object.position.y;
                createWallsSegments();
                setSectionsOuterEdgesAllCabinets(e);
                math.setSectionsOuterEdgesAllCabinets(sectionsOuterEdgesAllCabinets);
            }

            function dragEnd(e: any) {
                wallsSegments.splice(0, wallsSegments.length);
                sectionsOuterEdgesAllCabinets.splice(0, sectionsOuterEdgesAllCabinets.length);
                Camera.orbitControls.enabled = true;
                Corps_room.opacity.enabled = true;
                EventHandling.dragEvent = false;
                for (const i in Corps_cabinet.dragControls) {
                    Corps_cabinet.dragControls[i].enabled = true;
                }
                self.postMessage({ cabinetPositions: Corps_cabinet.cabinetPositions() });
            }

            function setSectionsOuterEdgesAllCabinets(e: any) {
                for (const cabinetId of ID.cabinets.items) {
                    if (cabinetId === e.object.id) {
                        continue;
                    } else {
                        const points = ( Scene.scene.getObjectById(cabinetId) as THREE.Object3D ).userData.outer;
                        const arrHelp = new Array();
                        for (const i of points) {
                            for (const index of points) {
                                if (i !== index) {
                                    if (!arrHelp.find(element => element.includes(i) && element.includes(index))) {
                                        arrHelp.push([i, index]);
                                        sectionsOuterEdgesAllCabinets.push([
                                            [
                                                ( Scene.scene.getObjectById(i) as THREE.Object3D ).matrixWorld.elements[12],
                                                ( Scene.scene.getObjectById(i) as THREE.Object3D ).matrixWorld.elements[14]
                                            ],
                                            [
                                                ( Scene.scene.getObjectById(index) as THREE.Object3D ).matrixWorld.elements[12],
                                                ( Scene.scene.getObjectById(index) as THREE.Object3D ).matrixWorld.elements[14]
                                            ]
                                        ]);
                                    }
                                }
                            }
                        }
                    }
                }
            }

            function mdrag(e: any) {
                EventHandling.dragEvent = true;
                points = cabinetPoints(e);
                const lerpVectors = math.drag(points, wallsSegments, e.object.userData.lerpVectors ? e.object.userData.lerpVectors : [], e.object.position.y, 0);
                // console.log(lerpVectors)
                if (lerpVectors.length === 1) {
                    e.object.position.copy(lastPosition);
                } else if (lerpVectors.length) {
                    e.object.userData.lerpVectors = lerpVectors;
                    // console.log(lerpVectors[8])
                    const quaternion = new THREE.Quaternion();
                    quaternion.setFromAxisAngle(
                        new THREE.Vector3(0, 1, 0),
                        ((lerpVectors[7] * 180 / Math.PI) % 360) * Math.PI / 180
                    );
                    e.object.quaternion.copy(quaternion);
                    e.object.position.lerpVectors(
                        new THREE.Vector3(lerpVectors[0], lerpVectors[1], lerpVectors[2]),
                        new THREE.Vector3(lerpVectors[3], lerpVectors[4], lerpVectors[5]),
                        lerpVectors[6]
                    );
                    if (lerpVectors[8]) {
                        delete e.object.userData.lerpVectors;
                    }
                }
                lastPosition.copy(e.object.position);
                if (!e.object.userData.cabinet_type.includes('upper')) {
                    e.object.position.y = e.object.userData.y
                }
            }

            function cabinetPoints(e: any) {
                const points = e.object.userData.outer;
                return [
                    [
                        e.object.position.x,
                        e.object.position.z
                    ],
                    [
                        (e.object.position.x + ( ( Scene.scene.getObjectById(points[1]) as THREE.Object3D ).matrixWorld.elements[12] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[12])),
                        (e.object.position.z + ( ( Scene.scene.getObjectById(points[1]) as THREE.Object3D ).matrixWorld.elements[14] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[14]))
                    ],
                    [
                        (e.object.position.x + ( ( Scene.scene.getObjectById(points[2]) as THREE.Object3D ).matrixWorld.elements[12] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[12])),
                        (e.object.position.z + ( ( Scene.scene.getObjectById(points[2]) as THREE.Object3D ).matrixWorld.elements[14] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[14]))
                    ],
                    [
                        (e.object.position.x + ( ( Scene.scene.getObjectById(points[3]) as THREE.Object3D ).matrixWorld.elements[12] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[12])),
                        (e.object.position.z + ( ( Scene.scene.getObjectById(points[3]) as THREE.Object3D ).matrixWorld.elements[14] -  ( Scene.scene.getObjectById(points[0]) as THREE.Object3D ).matrixWorld.elements[14]))
                    ]
                ]
            }

            function createWallsSegments() {
                for (const index in ID.room.walls.constructPoints.inside) {
                    const indexUp = parseInt(index) <= ID.room.walls.constructPoints.inside.length - 2 ? parseInt(index) + 1 : 0;
                    wallsSegments[index] = [
                        [ ( Scene.scene.getObjectById(ID.room.walls.constructPoints.inside[index]) as THREE.Object3D ).matrixWorld.elements[12],  ( Scene.scene.getObjectById(ID.room.walls.constructPoints.inside[index]) as THREE.Object3D ).matrixWorld.elements[14]],
                        [ ( Scene.scene.getObjectById(ID.room.walls.constructPoints.inside[indexUp]) as THREE.Object3D ).matrixWorld.elements[12],  ( Scene.scene.getObjectById(ID.room.walls.constructPoints.inside[indexUp]) as THREE.Object3D ).matrixWorld.elements[14]]
                    ];
                }
            }
        }

    }

    cabinet(name, id_cart) {
        if (ID.cabinets.id < 0) {
            const cabinets = new THREE.Group();
            cabinets.name = 'cabinets';
            Scene.scene.add(cabinets);
            ID.cabinets.id = cabinets.id;
        }
        const cabinet = new THREE.Group();
        cabinet.name = name;
        cabinet.userData.id_cart = id_cart;
        cabinet.userData.cabinet_type = this.data.general_corps_data.type;
        ( Scene.scene.getObjectById(ID.cabinets.id) as THREE.Object3D ).add(cabinet);
        this.ID = cabinet.id;
        ID.cabinets.items.push(cabinet.id);
        return Scene.scene.getObjectById(this.ID);
    }

    shadowMesh() {
        if (!Env.cabinets_cart_data) {
            const shadowTexture = new THREE.CanvasTexture(THREE.Cache.get(`${Env.base_url}static/corps/roundshadow.png`));
            const shadowMeshGeometry = new THREE.PlaneGeometry(1, 1);
            ID.geometry.push(shadowMeshGeometry.id);
            const shadowMeshMaterial = new THREE.MeshStandardMaterial({
                map: shadowTexture,
                transparent: true,
                depthWrite: false
            });
            ID.materials.push(shadowMeshMaterial.id);
            const shadowMesh = new THREE.Mesh(
                shadowMeshGeometry,
                shadowMeshMaterial
            );
            shadowMesh.name = 'shadowMesh';
            this.shadowMeshID = shadowMesh.id;
            ID.meshs.push(shadowMesh.id);
            shadowMesh.scale.setScalar(3)
            shadowMesh.rotation.x = -Math.PI / 2;
            shadowMesh.material.opacity = 0.5;
            Scene.scene.add(shadowMesh);
        }
    }

    forms() {
        for (let index in this.data.panels) {
            for (let i in this.data.panels[index]['3d_positions']) {
                const form = new Form(Form.prepareJSON( ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).name, this.data, index, i, this.ID));
                const element = form.create();
                if (element) {
                     ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).add(element);
                     ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).updateMatrixWorld();
                }
                form.accessories();
            }
        }
        return;
    }

    //wyśrodkowanie całej szafki
    position() {
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).updateMatrixWorld();
        const cube = new THREE.Box3().setFromObject( ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ));
        const size = cube.getSize(new THREE.Vector3);
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).position.x = -size.x / 2 - cube.min.x;
        if (Env.cabinets_cart_data) {
             ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).position.y = -cube.min.y;
        } else {
             ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).position.y = -size.y / 2;
             ( Scene.scene.getObjectById(this.shadowMeshID) as THREE.Object3D ).position.y = -size.y / 2 - 80 * Env.size_units;
        }
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).position.z = -size.z / 2 - cube.min.z;
    }

    accesories() {
        for (const index in this.data['3d_model']) {
            for (const i in this.data['3d_model'][index].position) {
                try {
                    if (!this.data['3d_model'][index].desk) {
                        transformLoadObject(this, THREE.Cache.get(this.data['3d_model'][index].url).clone(), index, i);
                    }
                } catch (e) {
                    console.debug(e);
                }
            }
        }

        function transformLoadObject(context, object, index, name) {
            let size = new THREE.Box3().setFromObject(object).getSize(new THREE.Vector3);
            if (context.data['3d_model'][index].rotate) {
                if (context.data['3d_model'][index]['rotate'].length > 0) {
                    let i = !(context.data['3d_model'][index]['rotate'].length > 1) ? 0 : 1;
                    object.rotation.set(context.data['3d_model'][index].rotate[i].x * (Math.PI / 180), context.data['3d_model'][index].rotate[i].y * (Math.PI / 180), context.data['3d_model'][index].rotate[i].z * (Math.PI / 180));
                }
            }
            object.updateMatrix();
            //scale
            if ('scale' in context.data['3d_model'][index]) {
                context.data['3d_model'][index].scale /= 10;
                object.scale.set(context.data['3d_model'][index].scale, context.data['3d_model'][index].scale, context.data['3d_model'][index].scale);
            } else if (context.data['3d_model'][index].szerokosc && context.data['3d_model'][index].dlugosc && context.data['3d_model'][index].grubosc) {
                object.scale.set((context.data['3d_model'][index].szerokosc * Env.size_units / size.x), (context.data['3d_model'][index].dlugosc * Env.size_units / size.y), (context.data['3d_model'][index].grubosc * Env.size_units / size.z));
            } else {
                let scale;
                if ('szerokosc' in context.data['3d_model'][index]) {
                    scale = context.data['3d_model'][index].szerokosc * Env.size_units / size.x;
                }
                if ('dlugosc' in context.data['3d_model'][index]) {
                    scale = context.data['3d_model'][index].dlugosc * Env.size_units / size.y;
                }
                if ('grubosc' in context.data['3d_model'][index]) {
                    scale = context.data['3d_model'][index].grubosc * Env.size_units / size.z;
                }
                object.scale.set(scale, scale, scale);
            }
            object.name = name + `#${index}`;
             ( Scene.scene.getObjectById(context.ID) as THREE.Object3D ).add(object);
             ( Scene.scene.getObjectById(context.ID) as THREE.Object3D ).updateMatrix();
            object.position.set(context.data['3d_model'][index].position[name].x * Env.size_units, context.data['3d_model'][index].position[name].y * Env.size_units, context.data['3d_model'][index].position[name].z * Env.size_units);
            ID.accessories.push(object.id);
            return object.id;
        }
    }

    helperPoints() {
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).updateMatrix();
        let cube = new THREE.Box3().setFromObject( ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ));
        const helperPointsGroup = new THREE.Group();
        helperPointsGroup.name = 'cabinetHelperPointsGroup';
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).add(helperPointsGroup);
        // const size = cube.getSize(new THREE.Vector3);
        let radius = 0.1 * Env.size_units;
        let geometry: THREE.SphereGeometry = Env.geometryLibrary.find((geometry: THREE.SphereGeometry) => geometry.parameters.radius === radius && geometry.type === 'SphereGeometry');
        if (!geometry) {
            geometry = new THREE.SphereGeometry(radius, 64, 32);
            Env.geometryLibrary.push(geometry);
        }
        ID.geometry.push(geometry.id);
        const material = new THREE.MeshBasicMaterial({ color: 'red' });
        ID.materials.push(material.id);
         ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ).userData.outer = [
            sphere('bl'), sphere('br'), sphere('fr'), sphere('fl')
        ];

        function sphere(position) {
            const sphere = new THREE.Mesh(geometry, material);
            ID.meshs.push(sphere.id);
            sphere.position.set(position.includes('l') ? cube.min.x : cube.max.x, 0, position.includes('b') ? cube.min.z : cube.max.z);
            helperPointsGroup.add(sphere);
            return sphere.id;
        }
    }

    add_plane() {
        Scene.scene.remove( ( Scene.scene.children.find(element => element.name === 'plane') as THREE.Object3D ) );
        let cube = new THREE.Box3(new THREE.Vector3).setFromObject( ( Scene.scene.getObjectById(this.ID) as THREE.Object3D ) );
        let geometry = new THREE.PlaneGeometry(2000, 2000);
        geometry.rotateX((-90 * (Math.PI / 180)));
        const material = new THREE.MeshPhongMaterial({
            color: 0xffffff,
            specular: 0x111111,
            transparent: true,
            opacity: 0.5,
            side: THREE.DoubleSide,
            fog: true
        });
        const plane = new THREE.Mesh(geometry, material);
        plane.name = 'plane';
        plane.position.y = cube.min.y - 1 * Env.size_units;
        plane.receiveShadow = true;
        Scene.scene.add(plane);

        const gridHelper = new THREE.GridHelper(2000, 2000);
        gridHelper.position.y = cube.min.y - 1 * Env.size_units;
        Scene.scene.add(gridHelper);
    }

    /**
     * metoda definiuje podstawową linię wymiarową
     * @param thickness
     * @param dimension
     * @param color
     * @returns {Object3D}
     */
    // dimension_lines_set(): void {
    // const cabinet = Scene.scene.getObjectById(this.ID);
    // const box = new THREE.Box3().setFromObject(cabinet);
    // const boxSize = box.getSize(new THREE.Vector3);

    // const group = new THREE.Group();

    // addLine(Corps_cabinet.width*Env.size_units, 0xff0000, new THREE.Vector3(0, Corps_cabinet.height*Env.size_units+80*Env.size_units, 0), new THREE.Vector3(0, 0, 0));
    // addLine(Corps_cabinet.height*Env.size_units, 0x00ff00, new THREE.Vector3(Corps_cabinet.width*Env.size_units+80*Env.size_units, 0, 0), new THREE.Vector3(0, Math.PI, Math.PI/2));
    // addLine(Corps_cabinet.depth*Env.size_units, 0x0000ff, new THREE.Vector3(Corps_cabinet.width*Env.size_units+80*Env.size_units, 0, 0), new THREE.Vector3(-Math.PI/2, 0, -Math.PI/2));

    static addLine(cabinetID: number, length: number, color: number, position = new THREE.Vector3, rotation = new THREE.Vector3) {

        const dimensionGroup = new THREE.Group();

        const shapes = [
            new THREE.Vector2(0, 0),//A
            new THREE.Vector2(60 * Env.size_units, -10 * Env.size_units), //B
            new THREE.Vector2(60 * Env.size_units, -2 * Env.size_units), //C
            new THREE.Vector2(length - 60 * Env.size_units, -2 * Env.size_units), //D
            new THREE.Vector2(length - 60 * Env.size_units, -10 * Env.size_units), //E
            new THREE.Vector2(length, 0), //F
            new THREE.Vector2(length - 60 * Env.size_units, 10 * Env.size_units), //G
            new THREE.Vector2(length - 60 * Env.size_units, 2 * Env.size_units), //H
            new THREE.Vector2(60 * Env.size_units, 2 * Env.size_units), //I
            new THREE.Vector2(60 * Env.size_units, 10 * Env.size_units), //J
        ];

        const shape = new THREE.Shape(shapes);

        const geometry = new THREE.ExtrudeGeometry(shape, {
            steps: 2,
            depth: .001,
            bevelEnabled: true,
            bevelThickness: 0,
            bevelSize: 0,
            bevelOffset: 0,
            bevelSegments: 0
        })

        const material = new THREE.MeshBasicMaterial({
            side: THREE.DoubleSide,
            color: new THREE.Color(color),
        })

        const mesh = new THREE.Mesh(geometry, material);

        dimensionGroup.add(mesh);

        const helperLine1 = helperLine(80);
        const helperLine2 = helperLine(80);
        helperLine2.position.x += length;
        dimensionGroup.add(helperLine1, helperLine2);

        function helperLine(height: number): THREE.Mesh {
            return new THREE.Mesh(
                new THREE.ExtrudeGeometry(
                    new THREE.Shape([
                        new THREE.Vector2(0, -height * Env.size_units),
                        new THREE.Vector2(2 * Env.size_units, -height * Env.size_units),
                        new THREE.Vector2(2 * Env.size_units, 0),
                        new THREE.Vector2(0, 0)
                    ]), {
                    steps: 2,
                    depth: .001,
                    bevelEnabled: true,
                    bevelThickness: 0,
                    bevelSize: 0,
                    bevelOffset: 0,
                    bevelSegments: 0
                }
                ),
                new THREE.MeshBasicMaterial({
                    side: THREE.DoubleSide,
                    color: new THREE.Color(0xc5c5c5)
                })
            );
        }
        dimensionGroup.position.copy(position);
        dimensionGroup.rotation.set(rotation.x, rotation.y, rotation.z);
        ( Scene.scene.getObjectById(cabinetID) as THREE.Object3D ).add(dimensionGroup);
        return dimensionGroup.id;
    }
    //     Scene.scene.getObjectById().add(group);
    // } /**this.dimension_lines_set()**END**/

    async annotation(obj, content, position = new THREE.Vector3, fontSize = null, backgroundColor = null, className = '') {
        (async function () {
            import(`${Env.base_url}static/js/corps/Three.js/renderers/CSS3DRenderer.js`)
                .then((module) => {
                    obj.localToWorld(obj);
                    const element = document.createElement('div');
                    element.innerHTML = content;
                    element.style.transform = 'scale(0.1)';
                    if (className !== '') {
                        element.className = className;
                    }
                    if (backgroundColor !== null) {
                        element.style.backgroundColor = backgroundColor;
                    }
                    if (fontSize !== null) {
                        element.style.fontSize = fontSize;
                    }
                    const object = new module.CSS3DObject(element);
                    if (position.x !== 0 || position.y !== 0 || position.z !== 0) {
                        object.position.set(position.x, position.y, position.z);
                    }
                    obj.add(object);
                });
            return;
        })();
        return this;
    }

    static cabinetPositions(json = {}, consoleLog = false) {
        try {
            if (Object.keys(json).length === 0) {
                json = {};
                for (let id of ID.cabinets.items) {
                    const cabinet = Scene.scene.getObjectById(id) as THREE.Object3D;
                    json[cabinet.userData.id_cart] = {
                        'position': Corps_cabinet.getWorldPosition(cabinet),
                        'rotation': { x: cabinet.rotation.x, y: cabinet.rotation.y, z: cabinet.rotation.z }
                    };
                }
                if (consoleLog)
                    console.debug(JSON.stringify(json));
                return json;
            } else {
                for (let index in json) {
                    for (let id of ID.cabinets.items) {
                        const cabinet = Scene.scene.getObjectById(id) as THREE.Object3D;
                        if (parseInt(cabinet.userData.id_cart) === parseInt(index)) {
                            cabinet.position.copy(json[index].position);
                            cabinet.rotation.set(
                                json[index].rotation.x,
                                json[index].rotation.y,
                                json[index].rotation.z
                            )
                        }
                    }
                }
            }
        } catch (e) {
            console.debug(e);
        }
    }

    static getWorldPosition(object) {
        return new THREE.Vector3(
            object.matrixWorld.elements[12],
            object.matrixWorld.elements[13],
            object.matrixWorld.elements[14]
        )
    }
}
